export const seoDataObj = {
  "": {
    title: "Jeffrey Bogart Portfolio",
    description: "",
    image: "",
  },
  "/work": {
    title: "Jeffrey Bogart Portfolio",
    description: "",
    image: "",
  },
};
